<template>
    <div>
        <BaseHospbasicinfo />
    </div>
</template>

<script>
import BaseHospbasicinfo from "./baseHospbasicinfoView.vue";
export default {
    components: {
        BaseHospbasicinfo,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
